import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=2df0ab84"
var script = {}
import style0 from "./Limit.vue?vue&type=style&index=0&id=2df0ab84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports